import React from 'react';
import {Box, Typography} from '@mui/material';

interface LabelValueProps {
  label: string;
  value: string | number;
  [key: string]: any;
}

const LabelValue: React.FC<LabelValueProps> = ({label, value, ...props}) => {
  return (
    <Box component="span" {...props}>
      <Typography
        sx={{
          fontSize: 14,
          marginBottom: 1,
          marginTop: 2,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontWeight: 700,
          marginRight: 1,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

export default LabelValue;
